export function formatAsPercentage(weight: number, fractionDigits = 0): string {
  return (weight * 100).toFixed(fractionDigits);
}
